module.exports = __webpack_public_path__ + "static/img/voice0.e7845f33.png";